import { useState } from 'react';
import { Alert } from '~/components/ui/Alert';
import { Button } from '~/components/ui/Button';
import type { AnnouncementBanner } from '~/lib/.server/banner';

export function Banner({ message, isWarning, canDismiss, updatedAt, cta }: AnnouncementBanner) {
  const [dismissed, setDismissed] = useState(
    globalThis.localStorage?.getItem('banner-dismissed') === updatedAt || false,
  );

  if (dismissed) {
    return null;
  }

  return (
    <div className="selection-accent z-max fixed top-4 left-1/2 -translate-x-1/2 max-w-full">
      <Alert
        type={isWarning ? 'warning' : 'info'}
        alignActions="end"
        actions={
          <>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => {
                if (canDismiss) {
                  localStorage.setItem('banner-dismissed', updatedAt);
                }

                setDismissed(true);
              }}
            >
              Dismiss
            </Button>
            {cta && (
              <Button size="sm" asChild>
                <a href={cta.href} target="_blank">
                  {cta.text}
                </a>
              </Button>
            )}
          </>
        }
      >
        {message}
      </Alert>
    </div>
  );
}
